import { useTranslations } from 'next-intl';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

export const MembersLimitMessage = () => {
  const t = useTranslations('features');
  return (
    <div className="flex items-center gap-2 py-1 px-2">
      <div>
        <Icon icon={IconsMap.INFO} className="w-6 h-6 text-red-500" />
      </div>
      <p>{t('manage-members.beyond_available_seats')}</p>
    </div>
  );
};
